<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M6.4 22q-1 0-1.6-.7T4 19.8V5.3H3V3.1h5.6V2h6.8v1.1H21v2.2h-1.1v14.5q0 .9-.7 1.5t-1.6.7zm2.2-4.4H11v-10H8.6zm4.5 0h2.3v-10H13z"
    />
  </svg>
</template>
